import IframeResizer from '@rio-cloud/iframe-resizer';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import { getWidgetVisibility } from '../../application/redux/widget/widgetSelectors';
import { gaPush, TRACKING_CATEGORIES } from '../../configuration/setup/googleTagManager';
import type { RootState } from '../../configuration/setup/store';

export const marketplaceUrlForGeo = 'https://upselling.marketplace.rio.cloud/?productId=rio-sku00000047&level=15';

const Upselling = (props: UpsellingProps) => {
    const { isWidgetVisible } = props;
    useEffect(() => {
        if (isWidgetVisible) {
            gaPush({
                category: TRACKING_CATEGORIES.UPSELLING,
                action: 'Geo Upselling Message Displayed',
                label: 'Displayed Geo Upselling Message',
            });
        }
    }, [isWidgetVisible]);

    return (
        <div className={'margin-bottom-20'}>
            <IframeResizer
                src={`${marketplaceUrlForGeo}&resourceId=''`}
                title={'RIO GEO marketplace offer'}
                height={0}
            />
        </div>
    );
};

type UpsellingProps = { isWidgetVisible: boolean };

const mapStateToProps = (state: RootState) => ({
    isWidgetVisible: getWidgetVisibility(state),
});

export const UpsellingContainer = connect(mapStateToProps, {})(Upselling);
